import React, { useEffect } from 'react';
import Brick from './BrickCore';
import { Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { Col, FormGroup, Label } from 'reactstrap';
import moment from 'moment';
import { loadScreenings } from '../../redux';
import { EMPTY_ARRAY } from '../../services';
import ScreeningsField from '../../components/ScreeningsField/ScreeningsField';

function BookOnTicketOptionsForm({ t, position }) {
    const dispatch = useDispatch();
    const screenings = useSelector(state => state.screenings?.screenings) || EMPTY_ARRAY;
    const prefix = `bricks[${position}].options`;
    const label = (key) => t(`workflows.bricks.book.on.ticket.options.${key}`);

    useEffect(() => {
        dispatch(loadScreenings({
            start_at_gte: moment().subtract(2, 'years').toISOString(),
            stop_at_lte: moment().add(366, 'days').toISOString(),
        }));
    }, [dispatch]);

    return (
        <>
            <FormGroup row>
                <Label for="ticket_id" className="text-v-center" sm={12}>
                    {label('ticket_id')}
                </Label>
                <Col sm={12}>
                    <Field
                        component="input"
                        type="text"
                        name={`${prefix}.ticket_id`}
                        className="form-control"
                        placeholder={label('ticket_id_placeholder')}
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label for="screening_id" className="text-v-center" sm={12}>
                    {label('screening_id')}
                </Label>
                <Col sm={12}>
                    <ScreeningsField
                        name={`${prefix}.screening_id`}
                        screenings={screenings}
                        placeholder={label('screening_id_placeholder')}
                        single
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label for="nb" className="text-v-center" sm={12}>
                    {label('nb')}
                </Label>
                <Col sm={12}>
                    <Field
                        component="input"
                        type="number"
                        name={`${prefix}.nb`}
                        className="form-control"
                        min={1}
                        placeholder="1"
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label for="api_key" className="text-v-center" sm={12}>
                    {label('api_key')}
                </Label>
                <Col sm={12}>
                    <Field
                        component="input"
                        type="text"
                        name={`${prefix}.api_key`}
                        className="form-control"
                        placeholder={label('api_key_placeholder')}
                    />
                </Col>
            </FormGroup>
        </>
    );
}

/** Workflow brick: book on an activated ticket (server-side). */
class BookOnTicketBrick extends Brick {
    /**
     * @param {Object} props
     * @param {Function} props.t
     */
    getOptionsForm(props) {
        const { t } = props;
        return <BookOnTicketOptionsForm t={t} position={this.position} />;
    }
}

export default BookOnTicketBrick;
